import { activeLoading, addAtt, removeAtt, select, selectAll } from "./functionAux";
import valideInputsTextForms from "./validatorInputsTexts";

export function initValideForms() {
    const eventsInput = ['keyup', 'keydown', 'change'];
    const forms = selectAll('[data-form-valide-name]');
    const arrayForm = [];

    forms.forEach(form => arrayForm.push(`[data-form-valide-name="${form.getAttribute('data-form-valide-name')}"]`));

    arrayForm.forEach(form => {
        const inputsForm = selectAll(`${form} [data-min-caracteres]`);
        let inputsAllValidete = false;

        eventsInput.forEach(evt => inputsForm.forEach(input => input.addEventListener(evt, () => {
            inputsAllValidete = valideInputsTextForms(form);

            (inputsAllValidete)
                ? removeAtt(`${form} button.valide-required`, 'disabled')
                : addAtt(`${form} button.valide-required`, 'disabled');
        })))
    });

    selectAll('.btn-env').forEach(btn => btn.addEventListener('click', activeLoading));
}
